import classNames from 'classnames';
import React from 'react';
import styles from './loader.scss';

import { Loader as WixLoader, LoaderSize } from '@wix/design-system';

interface Props {
  className?: string;
  dataHook?: string;
  size?: LoaderSize;
  text?: string;
}

export const Loader = ({ className, dataHook, size, text }: Props) => {
  return (
    <div className={classNames(styles.wrapper, className)} data-hook={dataHook}>
      <WixLoader size={size} text={text} />
    </div>
  );
};
